import { FC } from "react";
import styles from "./ProviderDocumentsPage.module.scss";
import { ProviderDocumentsList } from "@/components/ProviderDocuments";


export const ProviderDocumentsPage: FC = () => {

  return (
    <div className={styles.ProviderDocumentsPage}>
      <ProviderDocumentsList />
    </div>
  );
};

export default ProviderDocumentsPage;
